__turbopack_context__.v({
  "arrowIcon": "AiInRecruitingWhySection-module__yeNIGa__arrowIcon",
  "itemDesc": "AiInRecruitingWhySection-module__yeNIGa__itemDesc",
  "itemIcon": "AiInRecruitingWhySection-module__yeNIGa__itemIcon",
  "itemTitle": "AiInRecruitingWhySection-module__yeNIGa__itemTitle",
  "listItem": "AiInRecruitingWhySection-module__yeNIGa__listItem",
  "listWrapper": "AiInRecruitingWhySection-module__yeNIGa__listWrapper",
  "whySection": "AiInRecruitingWhySection-module__yeNIGa__whySection",
  "whySubtitle": "AiInRecruitingWhySection-module__yeNIGa__whySubtitle",
  "whyTitle": "AiInRecruitingWhySection-module__yeNIGa__whyTitle",
});
